import { Selection } from "components/DataTable";
import { FilterState } from "components/DataTable/DataTable";
import { Form } from "components/Form/base/Form";
import { FormSubmit } from "components/Form/next";
import { messageValidationSchema } from "components/MessageManagement/MessageComponent";
import { MessageFields } from "components/MessageManagement/MessageComponent/MessageFields";
import { useApi } from "../../../hooks/useApi";
import Joi from "joi";
import { omit } from "lodash";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useFetchFields from "../../Formular/hooks/useFetchFields";
import Loader from "../../Loader";
import useSWR from "swr";

interface Props {
    filter?: FilterState;
    eventId?: number;
    bookings: Selection;
    callback?: () => void;
}

const MessageComponent = ({ filter, bookings, eventId, callback }: Props) => {
    const { t } = useTranslation("bookings");
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const { data, isLoading: isLoadingEvent } = useSWR(`event/${eventId}`);
    const { fields, isLoading: isLoadingFields } = useFetchFields(data?.data?.form_id);

    const placeholders = useMemo(() => [
        { name: "user_name", title: t('booking.message.placeholders.userName') },
        { name: "created_at", title: t('booking.message.placeholders.createdAt') },
        { name: "cancelled_at", title: t('booking.message.placeholders.cancelledAt') },
        ...(fields?.filter(field => !["wysiwyg", "table"].includes(field.type)).map(({ name, label }) => ({
            name,
            title: label
        })) || [])
    ], [fields, t]);

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `booking/${eventId}/message `,
            method: "POST",
            data: { ...data, bookings, filter },
            onBefore: () => setIsLoading(false),
            onSuccess: () => callback?.()
        });
    };

    return (
        <Loader isLoading={isLoadingFields || isLoadingEvent}>
            <Form
                onSubmit={handleSubmit}
                validationSchema={Joi.object(
                    omit(messageValidationSchema, ["addresses", "addresses_cc", "addresses_bcc"])
                ).unknown()}
            >
                <MessageFields withoutAddresses placeholders={placeholders} />
                <FormSubmit isLoading={isLoading}>{t('booking.message.submit')}</FormSubmit>
            </Form>
        </Loader>
    );
};

export default MessageComponent;